module.exports = __webpack_public_path__ + "static/media/email-32.198a883d.svg";